module.exports = __webpack_public_path__ + "img/hero_5by3.9bbc2f0e.webp";